module.exports = __webpack_public_path__ + "img/kalina.464a7d70.png";